import { inputHandler } from 'utils/eventHandlers'

export const initialState = { tab: 'pages' }

const serviceMethods = {
  github: 'connectGitHub',
  google: 'connectGoogle',
  jira: 'connectJira',
  stripe: 'connectStripe'
}

const getChartData = (props, chartDate) => {
  props.getChanges(chartDate)
  props.getContributions(chartDate)
  props.getEvents(chartDate)
  props.getMRR(chartDate)
  props.getPages(chartDate)
  props.getSources(chartDate)
  props.getTasks(chartDate)
  props.getUsers(chartDate)
}

const mountHandler = api => () => {
  const { location, chartDate } = api.props
  const params = new URLSearchParams(location.search)
  getChartData(api.props, chartDate)
  if (params.has('code')) {
    const service = params.get('service')
    api.props[serviceMethods[service]]({ service, code: params.get('code') }, chartDate)
      .then(() => api.props.navigate('/'))
  }
}

const receiveHandler = api => nextProps => {
  if (api.props.chartDate !== nextProps.chartDate) {
    getChartData(api.props, nextProps.chartDate)
  }
}

const clickHandler = api => id => { api.props.setProfile({ id }, api.props.chartDate) }

const tabHandler = api => tab => { api.setState({ tab }) }

export default api => ({
  change: inputHandler(api),
  click: clickHandler(api),
  mount: mountHandler(api),
  receiveProps: receiveHandler(api),
  tab: tabHandler(api)
})